import { combineReducers } from "@reduxjs/toolkit";
import { colorPickerReducer } from "components/ColorPicker/state/reducer";
import { galleryReducer } from "components/Gallery/state/reducer";
import { IRootState } from "state/types";

export default combineReducers<IRootState>({
  colorPicker: colorPickerReducer,
  gallery: galleryReducer,
});
